import React from 'react';
import { Car, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SpotInfo = ({ spot, costPerDay }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:grid sm:grid-cols-2 items-start sm:items-center gap-2 sm:gap-4">
        <div className="flex items-center gap-2">
          <Car className="h-4 w-4 flex-shrink-0" />
          <span className="text-sm sm:text-base">{t('parking.spotInfo.spotNumber')}:</span>
        </div>
        <span className="font-medium text-sm sm:text-base pl-6 sm:pl-0">{spot.spot_number}</span>
      </div>

      <div className="flex flex-col sm:grid sm:grid-cols-2 items-start sm:items-center gap-2 sm:gap-4">
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 flex-shrink-0" />
          <span className="text-sm sm:text-base">{t('parking.spotInfo.costPerDay')}:</span>
        </div>
        <span className="font-medium text-sm sm:text-base pl-6 sm:pl-0">{costPerDay} {t('parking.spotInfo.points')}</span>
      </div>
    </div>
  );
};

export default SpotInfo;